import { FunctionComponent } from 'react';
import { EuiCallOut } from '@elastic/eui';
import { useSession } from 'next-auth/react';
import { useFeature } from '@lib/feature-toggles/useFeature';
import { FeatureFlag } from '@lib/feature-toggles/flags';

const MaintenanceBanner: FunctionComponent = () => {
  const isMaintenanceMode = useFeature(FeatureFlag.MaintenanceMode);
  const { data: session } = useSession();

  if (!isMaintenanceMode) return null;

  const message =
    session?.maintenanceMessage ?? 'We are down for scheduled maintenance.';

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}>
      <EuiCallOut
        title="Maintenance in progress"
        color="warning"
        iconType="alert">
        {message}
      </EuiCallOut>
    </div>
  );
};

export default MaintenanceBanner;
